<template>
  <div>
    <ContractServices
      v-if="contractType == 0 || contractType == 2"
      :productId="productId"
      :changeReason="changeReason"
      :changeReasonGroup="changeReasonGroup"
      @changedReason="changedReason"
      @changedReasonGroup="changedReasonGroup"
    />
    <ContractServicesLegacy
      v-if="contractType == 1"
      :changeReason="changeReason"
      :changeReasonGroup="changeReasonGroup"
      :billingMethod="billingMethod"
      @changedReason="changedReason"
      @changedReasonGroup="changedReasonGroup"
    />
  </div>
</template>

<script>
import ContractServicesLegacy from '@/components/contracts/ContractServicesLegacy';
import ContractServices from '@/components/contracts/ContractServices';

export default {
  name: 'CustomerContractServicesForm',
  components: {
    ContractServicesLegacy,
    ContractServices,
  },
  props: {
    productId: {
      type: [Number, String],
    },
    contractType: {
      type: [String, Number],
    },
    changeReason: String,
    changeReasonGroup: String,
    billingMethod: Number,
  },
  data() {
    return {
      data: {},
    };
  },
  methods: {
    beforeMount() {
      if (this.contractId !== 'add') {
        this.callData();
      }
    },
    changedReason(reason) {
      this.$emit('changedReason', reason);
    },
    changedReasonGroup(group) {
      this.$emit('changedReasonGroup', group);
    },
  },
};
</script>
